export const DEFAULT_DELAY = 400;

export const THROTTLE_LIMIT = 1000;
export const MIN_FILTER_YEAR = 1970;
